import { requestApi } from 'api/api'

export const getDocument = async (url: string) => {
  return requestApi({
    url,
    baseUrl: process.env.API_URL,
    method: 'GET',
    config: {
      responseType: 'arraybuffer',
    },
  })
}
